import { ButtonBase } from '@mui/material'
import Image from 'mui-image'
import React from 'react'

const GooglePlayButton = () => {
  return (
    <ButtonBase
      href="https://play.google.com/store/apps/details?id=com.DefaultCompany.LedDisplayApplication"
      target="_blank"
      sx={{
        width: "115px",
        height: "auto",
        boxShadow: "none",
      }}
    >
      <img src="./assets/google-play.png" width="115px" height="auto" />
    </ButtonBase>
  )
}

export default GooglePlayButton